import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// import { history } from '_helpers';
import { alertActions } from './alert.slice';
import { history, isCommentaryOnlyUser } from '../../../utils/basicHelpers';
import axios from 'axios';
import ToastComp from 'components/toast/ToastComp';

// create slice

const name = 'auth';
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();
const slice = createSlice({ name, initialState, reducers });

// exports

export const authActions = { ...slice.actions, ...extraActions };
export const authReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        value: JSON.parse(localStorage.getItem('auth') || '{}')
    }
}

function createReducers() {
    return {
        setAuth
    };

    function setAuth(state, action) {
        state.value = action.payload;
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_APIURL}`;

    return {
        login: login(),
        logout: logout()
    };

    function login() {
        return createAsyncThunk(
            `${name}/login`,
            async function ({ email, password }, { dispatch }) {
                dispatch(alertActions.clear());
                try {
                    let user = await axios.post(`${baseUrl}/users/login`,{ name : email, password });
                    user = user.data;
                    
                    dispatch(authActions.setAuth(user));

                    localStorage.setItem('auth', JSON.stringify({...user, password }));

                    // Commentary-only users (e.g. id 13) can only reach the
                    // commentary panel, so land them there instead of /matches.
                    if (isCommentaryOnlyUser(user)) {
                        history.navigate('/commentary/matches?sport=rugby-league');
                        return;
                    }

                    const { from } = history.location.state || { from: { pathname: '/matches', search: '?sport=football' } };
                    history.navigate(from);

                } catch (error) {
                    ToastComp({
                        varient: 'error',
                        message: error?.response?.data?.message ?? error?.message ?? 'Error Occured While Login'
                    })
                    dispatch(alertActions.error(error));
                }
            }
        );
    }

    function logout() {
        return createAsyncThunk(
            `${name}/logout`,
            function (arg, { dispatch }) {
                dispatch(authActions.setAuth(null));
                localStorage.removeItem('auth');
                history.navigate('/');
            }
        );
    }
}